import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/hover-prefetch-link.tsx");
